import { Injectable, Inject } from '@angular/core';
import { TRANSLATIONS } from './translations'; // import our opaque token

@Injectable()
export class TranslateService {
    private _currentLang: string = 'pt-br';

    public get currentLang() {
        return this._currentLang;
    }

    // inject our translations
    constructor( @Inject(TRANSLATIONS) private _translations: any) {
    }

    public use(lang: string): void {
        // set current language
        this._currentLang = lang;
    }

    private translate(key: string): string {
        // private perform translation
        let translation = key;

        if (this._translations[this.currentLang] && this._translations[this.currentLang].Textos && this._translations[this.currentLang].Textos[key]) {
            return this._translations[this.currentLang].Textos[key];
        }

        return translation;
    }
    
    public getCalendar(): any {
        if (this._translations[this.currentLang] && this._translations[this.currentLang].Calendar) {
            return this._translations[this.currentLang].Calendar;
        }
    }
  

    public instant(key: string) {
        // call translation
        return this.translate(key);
    }
}
